<template>
  <div class="help-center-button" @click="emit('click')">
    <div>
      <h5>{{ title }}</h5>
      <p>{{ description }}</p>
    </div>
    <RightOutlined />
  </div>
</template>

<script setup lang="ts">
import { RightOutlined } from "@ant-design/icons-vue";

defineProps<{
  title: string;
  description: string;
}>();

const emit = defineEmits<{
  (e: "click"): void;
}>();
</script>

<style scoped lang="sass">
.help-center-button
  padding: 12px 0px
  margin-bottom: 12px
  border-bottom: 1px solid #D9D9D9
  display: flex
  justify-content: space-between

  &:hover
    border-color: $blue-5
    cursor: pointer
  .anticon-right
    color: #1890FF

h5
  font-size: $font-normal
  font-weight: 600
  color: $gray-9
  margin: 0
  margin-bottom: 2px

p
  font-size: $font-small
  font-weight: 400
  color: $gray-8
  margin: 0
</style>
